module.exports = __webpack_public_path__ + "assets/img/out_(3).ba329158.gif";